import React, { useState } from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import { Drawer, Box, Card } from "@mui/material";
import Grid from "@mui/material/Grid";
import MonthYearFilter from "./MonthYearFilter";
import Payslip from "./Payslip";

const Payroll= () => {

  const [drawerOpen, setDrawerOpen] = useState(false);

  return(
    <>
    <Card sx={{ pt: 4, pb:15, pl:4, borderRadius: 3, height:650, width:"100%", display: "flex",flexDirection: "row"}}>
    <MonthYearFilter />
    <SoftBox>
    <SoftButton variant="gradient" color="info" size="small" sx={{ml:4, mt:6, width:"250px"}} onClick={() => setDrawerOpen(true)} >
                Download Salary Slip
    </SoftButton>
    <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)}
              PaperProps={{
            sx: { width: 1100, maxWidth: 1200 }, 
          }}
          >
                <Box p={3} width="1100px">
                 
                   <Payslip 
                   handleClose={() => setDrawerOpen(false)}/>
                </Box>
              </Drawer>
              </SoftBox>
    {/* <SoftButton
  variant="gradient"
  color="info"
  size="small"
  sx={{ ml: 5, mt: 10 }}
  onClick={() => window.open("/layouts/salary/components/Payslip", "_blank")}
>
  Download Salary Slip
</SoftButton> */}
  </Card>
    </>
  );
}

export default Payroll;
